'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContent = exports.getHeader = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getHeader = exports.getHeader = (0, _reselect.createSelector)(_common.getPageData, function (page) {
  return (0, _lodash2.default)(page, 'termsAndConditions.header');
});

var getContent = exports.getContent = (0, _reselect.createSelector)(_common.getCardData, function (card) {
  return (0, _lodash2.default)(card, 'termsAndConditions.content');
});